import { render, staticRenderFns } from "./LoginView.vue?vue&type=template&id=047164c4&"
import script from "./LoginView.vue?vue&type=script&lang=ts&"
export * from "./LoginView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports